import React, {useEffect, useState} from 'react'
import Select, { components } from 'react-select'
import {SearchPiece} from '../../../../components/SearchPiece'
import {getSearchPieceTypePiece} from '../../../../components/requests'
import CustomOption from './CustomOption'

const VehicleSearchFilter = (props) => {
  const {
    showFilter,
    setShowFilter,
    formik,
    customStyles,
    marqueVehicule,
    valueMarque,
    setValueMarque,
    modeleVehicule,
    valueModele,
    setValueModele,
    pieceTypePiece,
    selectedSearchValue,
    searchValue,
    setSearchValue,
    pieceSpinner,
    resultShowPiece,
    clearInput,
    setIsSearch,
    setClearInput,
    setFormattedCodePiece,
    setSearchPage,
    setSelectedSearchValue,
    setResultShowPiece,
    allModeleVehicule,
    setModeleVehicule,
    setPieceTypePiece,
    setPieceSpinner,
    timeoutRef,
    referenceConstValue,
    setReferenceConstValue,
    setSortField,
    setSortOrder,
    piecePubliable,
    setPiecePubliable,
    rechercheSite
  } = props

  const activateFilter = () => {
    setShowFilter(!showFilter)
  }
  const [disableReset, setDisableReset] = useState<boolean>(false)
  const [selectedModele, setSelectedModele] = useState<any>([])
  const [menuInputValue, setMenuInputValue] = useState<string>("")

  const handleMarqueChange = (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueMarque([])
      setModeleVehicule(allModeleVehicule)
      formik.setFieldValue('marque', '')
    } else {
      // definir la valeur choisi de marque
      setValueMarque(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const marques = data
        ? data
            .map((marque) => marque.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('marque', marques.toString())
    }
  }

  const handleModeleChange = (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueModele([])
      setSelectedModele([])
      formik.setFieldValue('modele', '')
    } else {
      // definir la valeur choisi de modele
      setValueModele(data)
      setSelectedModele(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const modeles = data
        ? data
            .map((modele) => modele.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('modele', modeles)
    }
  }

  const resetFilter = () => {
    setReferenceConstValue("")
    setClearInput(true)
    setSelectedSearchValue(null)
    setSearchValue('')
    setValueMarque([])
    setModeleVehicule(allModeleVehicule)
    setValueModele([])
    setSelectedModele([])
    formik.setFieldValue('immatriculation', '')
    formik.setFieldValue('reference', '')
    formik.setFieldValue('codePiece', '')
    formik.setFieldValue('codeVehicule', '')
    formik.setFieldValue('marque', '')
    formik.setFieldValue('modele', '')
    formik.setFieldValue('codeMoteur', '')
    setFormattedCodePiece('')
    setSearchPage({
      reference: '',
      codePiece: '',
      codeVehicule: '',
      marque: '',
      modele: '',
      codeMoteur: '',
      immatriculation: '',
      isSearch: true
    })
  }

  const searchPieceTypePiece = (e) => {
    const inputValue = e.target.value
    setSearchValue(inputValue)
    setSelectedSearchValue('')
    formik.setFieldValue('codePiece', '')
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      if (inputValue !== '') {
        setPieceSpinner(true)
        getSearchPieceTypePiece(inputValue, false, rechercheSite)
          .then((res) => {
            if (res?.status === 200) {
              if (res?.data !== undefined) {
                setResultShowPiece(true)
                setPieceTypePiece(res.data)
                setPieceSpinner(false)
              }
            }
          })
          .catch(() => {
            console.log('error')
          })
      }
    }, 800)
  }

  // Réinitialisation des champs immatricualtion / Marque / Modèle
  // Utilisé sur le clic du champ ref véhicule
  // Réinitialisation des champs immatricualtion / ref véhicule
  // Réinitialisation des champs immatricualtion / ref véhicule / code moteur / Marque / Modele / Code pièce
  const resetOnClick = (input: string) => {
    formik.setFieldValue('immatriculation', '')
    if (input === 'refVehicule') {
      setSearchValue('')
      setValueMarque([])
      setModeleVehicule(allModeleVehicule)
      setValueModele([])
      setSelectedModele([])
      formik.setFieldValue('marque', '')
      formik.setFieldValue('modele', '')
      return;
    }
    if (input === 'MarqueModele') {
      formik.setFieldValue('codeVehicule', '')
      return;
    }
    if (input === 'refOE') {
      setSelectedSearchValue('')
      setSearchValue('')
      setValueMarque([])
      setModeleVehicule(allModeleVehicule)
      setValueModele([])
      setSelectedModele([])
      formik.setFieldValue('marque', '')
      formik.setFieldValue('modele', '')
      formik.setFieldValue('codePiece', '')
      formik.setFieldValue('codeVehicule', '')
      formik.setFieldValue('codeMoteur', '')
      return;
    }
  }

  useEffect(() => {
    const immatriculation = formik.values.immatriculation
    const codeVehicule = formik.values.codeVehicule
    const codeMoteur = formik.values.codeMoteur
    const reference = formik.values.reference

    const isMarqueEmpty = !valueMarque || valueMarque.length === 0
    const isModeleEmpty = !valueModele || valueModele.length === 0

    const isSearchEmpty = searchValue === '' && !selectedSearchValue
    const isFormikEmpty = immatriculation === ''
      && codeVehicule === ''
      && codeMoteur === ''
      && reference === ''

    if (isFormikEmpty && isMarqueEmpty && isModeleEmpty && isSearchEmpty) {
      setDisableReset(true)
    } else {
      setDisableReset(false)
    }
    if (isSearchEmpty) {
      formik.setFieldValue('codePiece', '')
      setFormattedCodePiece('')
    }
  }, [
    formik.values.immatriculation,
    formik.values.codeVehicule,
    formik.values.codeMoteur,
    formik.values.reference,
    valueMarque,
    valueModele,
    searchValue,
    selectedSearchValue
  ])

  useEffect(() => {
    if (modeleVehicule.length > 0) setSelectedModele(valueModele)
  }, [modeleVehicule])

  const filterOptions = (candidate: any, input: string) => {
    if (input) {
      // return candidate.label.toLowerCase().includes(input.toLowerCase())
      const normalize = (text: string) =>
          text.replace(/\s*-\s*/g, ' - ').toLowerCase() // remplacer le "-"  en " - "

      return normalize(candidate.label).includes(normalize(input))
    }
    return true
  }

  return (
    <div className='card border p-5 mb-3'>
      <div className='d-flex justify-content-between'>
        <h3 className='mb-3'>Filtres de recherche</h3>
        <div className='d-flex gap-5'>
          <div className='form-check form-check-custom form-check-solid form-check-sm'>
            <input
              type='checkbox'
              className='form-check-input fw-bold fs-6'
              onClick={() => setPiecePubliable(!piecePubliable)}
              checked={!piecePubliable}
              id={'piecePubliable'}
            />
            <label className='form-check-label text-gray-600 fs-6' htmlFor='piecePubliable'>
              Intégrer les pièces non publiable
            </label>
          </div>
          <span className={`btn btn-icon btn-bg-light btn-sm`} onClick={() => activateFilter()}>
            <i className={`ki-duotone ki-filter fs-2x ${showFilter && 'text-info'}`}>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
          </span>
        </div>
      </div>
      {showFilter && (
        <form onSubmit={formik.handleSubmit}>
          <div className='card-header border-0 pt-5 pb-5 d-flex justify-content-between gap-6'>
            <div className='form-group col'>
              <div className='input-group'>
                <input
                  type='text'
                  className='form-control form-control-md'
                  {...formik.getFieldProps('immatriculation')}
                  name='immatriculation'
                  placeholder='Immatriculation'
                  value={formik.values.immatriculation}
                />
              </div>
            </div>
            <div className='form-group col'>
              <div className='input-group'>
                <input
                  type='text'
                  className='form-control form-control-md'
                  {...formik.getFieldProps('codeVehicule')}
                  onClick={() => resetOnClick('refVehicule')}
                  name='codeVehicule'
                  placeholder='Rech. par NE véhicule'
                />
              </div>
            </div>
            <div className='form-group col'>
              <div style={{width: '-webkit-fill-available'}}>
                <div className='input-group'>
                  <input
                    type='text'
                    className='form-control form-control-md'
                    {...formik.getFieldProps('codeMoteur')}
                    name='codeMoteur'
                    placeholder='Rech. par code moteur'
                  />
                </div>
              </div>
            </div>
            <div className='form-group col' onClick={() => resetOnClick('MarqueModele')}>
              <Select
                styles={customStyles}
                className='react-select-styled react-select-solid react-select-lg'
                classNamePrefix='react-select'
                options={marqueVehicule}
                value={valueMarque}
                placeholder='Rech. par marque'
                isDisabled={marqueVehicule.length === 0}
                isLoading={marqueVehicule.length === 0}
                isClearable
                isMulti
                onChange={(data) => handleMarqueChange(data)}
              />
              {/*<span className='badge badge-primary mt-3'>*/}
              {/*  {state?.selectedPiecesFromVehicle[0].marque}*/}
              {/*</span>*/}
            </div>
          </div>
          <div className='card-header border-0 pb-5 d-flex justify-content-between gap-6'>
            <div className='form-group col' onClick={() => resetOnClick('MarqueModele')}>
              <Select
                styles={customStyles}
                className='react-select-styled react-select-solid react-select-lg'
                classNamePrefix='react-select'
                options={modeleVehicule}
                value={selectedModele}
                placeholder='Rech. par modèle'
                isDisabled={modeleVehicule.length === 0}
                isLoading={modeleVehicule.length === 0}
                isClearable
                isMulti
                onChange={(data) => handleModeleChange(data)}
                components={{Option: CustomOption}}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                blurInputOnSelect={false}
                filterOption={filterOptions}
                inputValue={menuInputValue}
                onInputChange={(text, action) => {
                  if (action.action === 'input-change') {
                    setMenuInputValue(text)
                  } else if (action.action === 'menu-close' || action.action === 'input-blur') {
                    setMenuInputValue('')
                  }
                }}
              />
              {/*<span className='badge badge-primary mt-3'>*/}
              {/*  {state?.selectedPiecesFromVehicle[0].modele}*/}
              {/*</span>*/}
            </div>
            <div className='form-group col'>
              <SearchPiece
                inputClassName={'form-control form-control-md h-200'}
                placeholder={'Rech. par libellé de la pièce'}
                onChange={(e) => searchPieceTypePiece(e)}
                resultatPiece={pieceTypePiece}
                value={selectedSearchValue || searchValue}
                setSearchValue={setSearchValue}
                pieceSpinner={pieceSpinner}
                resultShowPiece={resultShowPiece}
                clearInput={clearInput}
                selectedSearchValue={selectedSearchValue}
                setSelectedSearchValue={setSelectedSearchValue}
                showPieceHn={false}
                onSelect={(pieceTypePiece) => {
                  if (pieceTypePiece) {
                    setSearchValue(pieceTypePiece?.nom)
                    setSelectedSearchValue(pieceTypePiece?.nom)
                    const fullCode = `${pieceTypePiece?.sousCategorie?.categorie?.code}${pieceTypePiece?.sousCategorie?.code}${pieceTypePiece?.code}`
                    formik.setFieldValue('codePiece', fullCode)
                    setFormattedCodePiece(fullCode)
                  } else {
                    formik.setFieldValue('codePiece', '')
                    setFormattedCodePiece('')
                  }
                  setResultShowPiece(false)
                  setClearInput(true)
                }}
              />
            </div>
            <div className='form-group col'>
              <div className='input-group'>
                <input
                  type='text'
                  className='form-control form-control-md'
                  {...formik.getFieldProps('reference')}
                  name='reference'
                  placeholder='Rech. par ref. constructeur'
                  value={referenceConstValue}
                  onClick={() => resetOnClick('refOE')}
                  onChange={(e) => {
                    setReferenceConstValue(e.target.value)
                    formik.setFieldValue('reference', e.target.value)
                  }}
                />
              </div>
              {/*{state?.selectedPiecesFromVehicle[0].referenceConstructeur && (*/}
              {/*  <span className='badge badge-primary mt-3'>*/}
              {/*    {state?.selectedPiecesFromVehicle[0].referenceConstructeur}*/}
              {/*  </span>*/}
              {/*)}*/}
            </div>
            <div className='form-group col'>
              <div className='d-flex gap-3'>
                <button
                  className='btn btn-light-info flex-fill'
                  type='submit'
                  onClick={() => {
                    setSortField('')
                    setSortOrder('')
                  }}
                >
                  Rechercher
                </button>
                <button
                  className={`btn btn-light-warning flex-fill ${disableReset ? 'disabled' : ''}`}
                  type='button'
                  onClick={() => resetFilter()}
                >
                  Réinitialiser
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  )
}

export default VehicleSearchFilter